export var PolicyType;
(function (PolicyType) {
    PolicyType["AUTO"] = "AUTO";
    PolicyType["HOME"] = "HOME";
    PolicyType["LIFE"] = "LIFE";
    PolicyType["HEALTH"] = "HEALTH";
})(PolicyType || (PolicyType = {}));
export var PolicyStatus;
(function (PolicyStatus) {
    PolicyStatus["ACTIVE"] = "ACTIVE";
    PolicyStatus["EXPIRED"] = "EXPIRED";
    PolicyStatus["CANCELLED"] = "CANCELLED";
    PolicyStatus["PENDING"] = "PENDING";
})(PolicyStatus || (PolicyStatus = {}));
export var PropertyType;
(function (PropertyType) {
    PropertyType["HOUSE"] = "HOUSE";
    PropertyType["APARTMENT"] = "APARTMENT";
    PropertyType["OFFICE"] = "OFFICE";
    PropertyType["WAREHOUSE"] = "WAREHOUSE";
})(PropertyType || (PropertyType = {}));
export var ClaimType;
(function (ClaimType) {
    ClaimType["ACCIDENT"] = "ACCIDENT";
    ClaimType["THEFT"] = "THEFT";
    ClaimType["FIRE"] = "FIRE";
    ClaimType["FLOOD"] = "FLOOD";
    ClaimType["VANDALISM"] = "VANDALISM";
    ClaimType["OTHER"] = "OTHER";
})(ClaimType || (ClaimType = {}));
export var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["REPORTED"] = "REPORTED";
    ClaimStatus["UNDER_REVIEW"] = "UNDER_REVIEW";
    ClaimStatus["APPROVED"] = "APPROVED";
    ClaimStatus["REJECTED"] = "REJECTED";
    ClaimStatus["CLOSED"] = "CLOSED";
})(ClaimStatus || (ClaimStatus = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["PHOTO"] = "PHOTO";
    DocumentType["POLICE_REPORT"] = "POLICE_REPORT";
    DocumentType["MEDICAL_REPORT"] = "MEDICAL_REPORT";
    DocumentType["INVOICE"] = "INVOICE";
    DocumentType["OTHER"] = "OTHER";
})(DocumentType || (DocumentType = {}));
export var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus["DRAFT"] = "DRAFT";
    QuoteStatus["ACTIVE"] = "ACTIVE";
    QuoteStatus["EXPIRED"] = "EXPIRED";
    QuoteStatus["CONVERTED"] = "CONVERTED";
})(QuoteStatus || (QuoteStatus = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethod["DEBIT_CARD"] = "DEBIT_CARD";
    PaymentMethod["BANK_TRANSFER"] = "BANK_TRANSFER";
    PaymentMethod["CASH"] = "CASH";
    PaymentMethod["AUTO_DEBIT"] = "AUTO_DEBIT";
})(PaymentMethod || (PaymentMethod = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["OVERDUE"] = "OVERDUE";
    PaymentStatus["CANCELLED"] = "CANCELLED";
    PaymentStatus["REFUNDED"] = "REFUNDED";
})(PaymentStatus || (PaymentStatus = {}));
export var FieldType;
(function (FieldType) {
    FieldType["TEXT"] = "TEXT";
    FieldType["EMAIL"] = "EMAIL";
    FieldType["PASSWORD"] = "PASSWORD";
    FieldType["NUMBER"] = "NUMBER";
    FieldType["DATE"] = "DATE";
    FieldType["SELECT"] = "SELECT";
    FieldType["CHECKBOX"] = "CHECKBOX";
    FieldType["RADIO"] = "RADIO";
    FieldType["TEXTAREA"] = "TEXTAREA";
    FieldType["FILE"] = "FILE";
})(FieldType || (FieldType = {}));
export var ValidationType;
(function (ValidationType) {
    ValidationType["REQUIRED"] = "REQUIRED";
    ValidationType["MIN_LENGTH"] = "MIN_LENGTH";
    ValidationType["MAX_LENGTH"] = "MAX_LENGTH";
    ValidationType["PATTERN"] = "PATTERN";
    ValidationType["EMAIL"] = "EMAIL";
    ValidationType["MIN_VALUE"] = "MIN_VALUE";
    ValidationType["MAX_VALUE"] = "MAX_VALUE";
})(ValidationType || (ValidationType = {}));
